import {
  HOME_PAGE_URL,
  GALLERY_PAGE_URL,
  SESSIONS_PAGE_URL,
  FANSITES_PAGE_URL,
  CONTACT_PAGE_URL,
  ABOUT_PAGE_URL,
} from '../Constants';

export const getNavLinkItemsArray = (user) => [
  { path: HOME_PAGE_URL, label: 'Home' },
  { path: ABOUT_PAGE_URL, label: 'About Me' },
  { path: SESSIONS_PAGE_URL, label: 'Sessions' },
  { path: FANSITES_PAGE_URL, label: 'Fansites' },
  { path: GALLERY_PAGE_URL, label: 'Gallery' },
  { path: CONTACT_PAGE_URL, label: 'Contact' },
];
